// @ts-nocheck
(function () {
    const dealerApiUrl = "/sfapi/default/dealers?$expand=LocationsDetail";
    const dealerTerritoryApiUrl = "/dealer-api/get";
    const SEARCH_RADIUS_MILES = 75;
    const US_ZIP = /^\d{5}$/;
    const CA_POSTAL = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
    const DOMESTIC_COUNTRY_VALUES = [
        "united states",
        "usa",
        "us",
        "u.s.",
        "u.s.a.",
        "canada",
        "ca",
        "can",
    ];

    let dealerCache = null;
    let dealerCachePromise = null;

    document.addEventListener("DOMContentLoaded", init);

    function init() {
        const zipInput = document.getElementById("Textbox-6");
        const countrySelect = document.getElementById("Dropdown-2");
        const productType = document.getElementById("Dropdown-3");
        const dealerEmail = document.getElementById("HiddenField-1");
        const dealerTitle = document.getElementById("HiddenField-2");
        const dealerCity = document.getElementById("HiddenField-3");
        const dealerState = document.getElementById("HiddenField-4");
        const dealerContact = document.getElementById("HiddenField-5");

        if (!zipInput || !countrySelect || !productType || !dealerEmail) {
            return;
        }

        const dealerFields = {
            email: dealerEmail,
            title: dealerTitle,
            city: dealerCity,
            state: dealerState,
            contact: dealerContact,
        };

        const formContainer = document.querySelector('[data-sf-role="form-container"]');
        const form = formContainer?.querySelector("form") || zipInput.closest("form");

        const zipError = document.createElement("div");
        zipError.className = "zip-error form__error";
        zipError.setAttribute("role", "alert");
        zipError.setAttribute("aria-live", "polite");
        zipInput.insertAdjacentElement("afterend", zipError);

        let bypassSubmitGuard = false;
        let lookupRequestId = 0;

        function getLookupKey() {
            return [
                zipInput.value.trim(),
                countrySelect.value,
                productType.value.trim(),
            ].join("|");
        }

        function isLookupStale(requestId, lookupKeyAtStart) {
            return requestId !== lookupRequestId || getLookupKey() !== lookupKeyAtStart;
        }

        function normalizeCountryValue(value) {
            return (value || "").trim().toLowerCase();
        }

        function isDomesticCountry() {
            return DOMESTIC_COUNTRY_VALUES.includes(normalizeCountryValue(countrySelect.value));
        }

        function isCanadaCountry(country) {
            const normalized = normalizeCountryValue(country);
            return normalized === "canada" || normalized === "ca" || normalized === "can";
        }

        function showZipError(message) {
            zipError.textContent = message;
            zipInput.classList.add("input-error");
        }

        function clearZipError() {
            zipError.textContent = "";
            zipInput.classList.remove("input-error");
        }

        function validateZip(country, zipValue) {
            if (isCanadaCountry(country)) {
                return CA_POSTAL.test(zipValue)
                    ? null
                    : "Please enter a valid Canadian postal code (e.g., A1A 1A1).";
            }

            return US_ZIP.test(zipValue)
                ? null
                : "Please enter a valid 5-digit US ZIP code.";
        }

        function enforceZipInputRules() {
            const country = countrySelect.value;
            let value = zipInput.value.toUpperCase();

            if (isCanadaCountry(country)) {
                value = value.replace(/[^A-Z0-9]/gi, "").slice(0, 6);
                value = value.replace(/(.{3})(.{3})/, "$1 $2");
            } else {
                value = value.replace(/\D/g, "").slice(0, 5);
            }

            zipInput.value = value;
        }

        function clearDealerFields() {
            Object.values(dealerFields).forEach((field) => {
                if (field) {
                    field.value = "";
                }
            });
        }

        function populateDealerFields(dealer) {
            dealerFields.email.value = dealer.Email || "";
            if (dealerFields.title) dealerFields.title.value = dealer.Title || "";
            if (dealerFields.city) dealerFields.city.value = getDealerAddress(dealer).City || "";
            if (dealerFields.state) {
                dealerFields.state.value =
                    getDealerAddress(dealer).StateCode || getDealerAddress(dealer).State || "";
            }
            if (dealerFields.contact) dealerFields.contact.value = dealer.Contact || "";
            return !!dealerFields.email.value.trim();
        }

        function isTruthyFlag(value) {
            if (value === false || value === 0 || value === null || value === undefined) {
                return false;
            }

            if (typeof value === "string") {
                const normalized = value.trim().toLowerCase();
                return normalized === "true" || normalized === "yes" || normalized === "1";
            }

            return !!value;
        }

        function isInternationalDealer(dealer) {
            return isTruthyFlag(dealer.InternationalDealer);
        }

        function getDealerAddress(dealer) {
            return dealer.Address || dealer.address || {};
        }

        function isResidentialProduct(productTypeValue) {
            const value = productTypeValue.toLowerCase();
            return value.includes("residential") || value.includes("garage");
        }

        function isCommercialProduct(productTypeValue) {
            const value = productTypeValue.toLowerCase();
            return (
                value.includes("commercial") ||
                value.includes("dock") ||
                value.includes("industrial")
            );
        }

        function dealerMatchesProductType(dealer, productTypeValue) {
            const isResidential = isTruthyFlag(dealer.ResidentialDealer);
            const isCommercial = isTruthyFlag(dealer.CommercialDealer);

            if (isResidentialProduct(productTypeValue)) {
                return isResidential;
            }

            if (isCommercialProduct(productTypeValue)) {
                return isCommercial;
            }

            return isResidential || isCommercial;
        }

        function fetchDealers() {
            if (dealerCache) {
                return Promise.resolve(dealerCache);
            }

            if (dealerCachePromise) {
                return dealerCachePromise;
            }

            const pageSize = 100;

            function fetchPage(skip) {
                const url = `${dealerApiUrl}&$top=${pageSize}&$skip=${skip}`;

                return fetch(url, {
                    credentials: "include",
                    headers: {
                        accept: "application/json;odata=verbose",
                    },
                })
                    .then((response) => {
                        if (!response.ok) {
                            throw new Error(`Dealer API returned ${response.status}`);
                        }
                        return response.json();
                    })
                    .then((data) => {
                        const page = data.value || [];

                        if (page.length < pageSize) {
                            return page;
                        }

                        return fetchPage(skip + pageSize).then((rest) => page.concat(rest));
                    });
            }

            dealerCachePromise = fetchPage(0)
                .then((dealers) => {
                    dealerCache = dealers;
                    return dealerCache;
                })
                .finally(() => {
                    dealerCachePromise = null;
                });

            return dealerCachePromise;
        }

        function getDealerTerritoryStates(stateCode) {
            if (!stateCode) {
                return Promise.resolve(null);
            }

            const url = `${dealerTerritoryApiUrl}?stateCode=${encodeURIComponent(stateCode)}`;

            return fetch(url, {
                credentials: "include",
                headers: {
                    accept: "application/json;odata=verbose",
                },
            })
                .then((response) => {
                    if (!response.ok) {
                        return null;
                    }
                    return response.json();
                })
                .then((territory) => {
                    if (!territory || typeof territory !== "string") {
                        return null;
                    }

                    return territory
                        .split(",")
                        .map((state) => state.trim())
                        .filter(Boolean);
                })
                .catch(() => null);
        }

        function parseArcGisCandidate(data) {
            if (!data?.candidates?.length) {
                return null;
            }

            const candidate = data.candidates[0];
            return {
                lat: candidate.location.y,
                lon: candidate.location.x,
                state: candidate.attributes?.Region || "",
            };
        }

        function geocodeWithArcGis(postalCode, countryCode) {
            const endpoint =
                "https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/findAddressCandidates";
            const singleLineUrl =
                `${endpoint}?f=json&singleLine=${encodeURIComponent(postalCode)}` +
                `&countryCode=${countryCode}&category=Postal&maxLocations=1&outFields=Region,Country`;
            const postalUrl =
                `${endpoint}?f=json&Postal=${encodeURIComponent(postalCode)}` +
                `&CountryCode=${countryCode}&maxLocations=1&outFields=Region,Country`;

            return fetch(singleLineUrl)
                .then((response) => response.json())
                .then((data) => parseArcGisCandidate(data))
                .then((location) => {
                    if (location) {
                        return location;
                    }

                    return fetch(postalUrl)
                        .then((response) => response.json())
                        .then((data) => parseArcGisCandidate(data));
                });
        }

        function geocodeWithGoogle(postalCode, countryName) {
            if (!window.google?.maps?.Geocoder) {
                return Promise.resolve(null);
            }

            const geocoder = new google.maps.Geocoder();
            const address = isCanadaCountry(countryName)
                ? `${postalCode}, Canada`
                : `${postalCode}, USA`;

            return new Promise((resolve) => {
                geocoder.geocode({ address }, (results, status) => {
                    if (status !== google.maps.GeocoderStatus.OK || !results?.length) {
                        resolve(null);
                        return;
                    }

                    let state = "";
                    results[0].address_components.forEach((component) => {
                        if (component.types.includes("administrative_area_level_1")) {
                            state = component.short_name;
                        }
                    });

                    resolve({
                        lat: results[0].geometry.location.lat(),
                        lon: results[0].geometry.location.lng(),
                        state,
                    });
                });
            });
        }

        function geocodePostalCode(postalCode, countryCode, countryName) {
            return geocodeWithArcGis(postalCode, countryCode).then((location) => {
                if (location) {
                    return location;
                }

                return geocodeWithGoogle(postalCode, countryName);
            });
        }

        function selectBestDealerMatch(dealers) {
            const uniqueDealers = [];
            const seenIds = new Set();

            dealers.forEach((dealer) => {
                const dealerId = dealer.Id || dealer.Title;
                if (!seenIds.has(dealerId)) {
                    seenIds.add(dealerId);
                    uniqueDealers.push(dealer);
                }
            });

            const tier2WithEmail = uniqueDealers.find(
                (dealer) => String(dealer.TierLevel) === "2" && dealer.Email?.trim()
            );
            if (tier2WithEmail) {
                return tier2WithEmail;
            }

            const withEmail = uniqueDealers.find((dealer) => dealer.Email?.trim());
            return withEmail || null;
        }

        function dealerInTerritory(dealer, territoryStates) {
            if (!territoryStates || territoryStates.length === 0) {
                return true;
            }

            const address = getDealerAddress(dealer);
            const dealerStateCode = address.StateCode || address.State;
            return dealerStateCode && territoryStates.includes(dealerStateCode);
        }

        function findClosestDealer(userLat, userLon, productTypeValue, territoryStates) {
            return fetchDealers().then((dealers) => {
                const tier2DealersNearby = [];
                const dealersInTerritory = [];

                dealers.forEach((dealer) => {
                    if (isInternationalDealer(dealer) || !dealerMatchesProductType(dealer, productTypeValue)) {
                        return;
                    }

                    if (!dealerInTerritory(dealer, territoryStates)) {
                        return;
                    }

                    const address = getDealerAddress(dealer);
                    const dealerLat = parseFloat(address.Latitude);
                    const dealerLon = parseFloat(address.Longitude);

                    if (isNaN(dealerLat) || isNaN(dealerLon)) {
                        return;
                    }

                    dealersInTerritory.push(dealer);

                    const distance = calculateDistance(userLat, userLon, dealerLat, dealerLon);

                    if (distance <= SEARCH_RADIUS_MILES && String(dealer.TierLevel) === "2") {
                        tier2DealersNearby.push({ dealer, distance });
                    }
                });

                tier2DealersNearby.sort((a, b) => a.distance - b.distance);

                const nearbyCandidates = tier2DealersNearby.map((entry) => entry.dealer);
                const withinRadius = dealersInTerritory.filter((dealer) => {
                    const dealerLat = parseFloat(getDealerAddress(dealer).Latitude);
                    const dealerLon = parseFloat(getDealerAddress(dealer).Longitude);
                    return calculateDistance(userLat, userLon, dealerLat, dealerLon) <= SEARCH_RADIUS_MILES;
                });

                const candidates = [
                    ...nearbyCandidates,
                    ...withinRadius,
                ].filter(Boolean);

                const uniqueCandidates = [];
                const seenIds = new Set();

                candidates.forEach((dealer) => {
                    const dealerId = dealer.Id || dealer.Title;
                    if (!seenIds.has(dealerId)) {
                        seenIds.add(dealerId);
                        uniqueCandidates.push(dealer);
                    }
                });

                return selectBestDealerMatch(uniqueCandidates);
            });
        }

        function resolveDealerForZip(zipValue, country, countryCode, productTypeValue) {
            return geocodePostalCode(zipValue, countryCode, country).then((location) => {
                if (!location) {
                    return null;
                }

                return getDealerTerritoryStates(location.state).then((territoryStates) =>
                    findClosestDealer(
                        location.lat,
                        location.lon,
                        productTypeValue,
                        territoryStates
                    )
                );
            });
        }

        function assignDealerFromZip(requestId, lookupKeyAtStart) {
            const zipValue = zipInput.value.trim();
            const country = countrySelect.value;
            const productTypeValue = productType.value.trim();

            clearZipError();

            if (!isDomesticCountry()) {
                return Promise.resolve(true);
            }

            const zipValidationMessage = validateZip(country, zipValue);
            if (zipValidationMessage) {
                showZipError(zipValidationMessage);
                return Promise.resolve(false);
            }

            if (!productTypeValue) {
                showZipError("Please select a product type.");
                productType.focus();
                return Promise.resolve(false);
            }

            const countryCode = isCanadaCountry(country) ? "CAN" : "USA";

            return resolveDealerForZip(zipValue, country, countryCode, productTypeValue)
                .then((dealer) => {
                    if (isLookupStale(requestId, lookupKeyAtStart)) {
                        return null;
                    }

                    if (!dealer) {
                        showZipError(
                            "We could not find a dealer for your area. Please try a different ZIP/postal code."
                        );
                        clearDealerFields();
                        return false;
                    }

                    const hasEmail = populateDealerFields(dealer);
                    if (!hasEmail) {
                        showZipError(
                            "We found a dealer for your area but could not route your request. Please call us or use Where to Buy."
                        );
                        clearDealerFields();
                        return false;
                    }

                    clearZipError();
                    return true;
                })
                .catch((error) => {
                    if (isLookupStale(requestId, lookupKeyAtStart)) {
                        return null;
                    }

                    console.error("Error assigning dealer from ZIP:", error);
                    showZipError("We could not match you with a dealer right now. Please try again.");
                    return false;
                });
        }

        function queueAssignDealerFromZip() {
            lookupRequestId += 1;
            const requestId = lookupRequestId;
            const lookupKeyAtStart = getLookupKey();
            return assignDealerFromZip(requestId, lookupKeyAtStart);
        }

        function shouldReassignDealerOnSubmit() {
            return isDomesticCountry();
        }

        function handleZipBlur() {
            if (!isDomesticCountry()) {
                return;
            }

            const zipValue = zipInput.value.trim();
            const productTypeValue = productType.value.trim();
            const zipValidationMessage = validateZip(countrySelect.value, zipValue);

            if (zipValue && zipValidationMessage) {
                showZipError(zipValidationMessage);
                clearDealerFields();
                return;
            }

            if (!zipValue || !productTypeValue || zipValidationMessage) {
                return;
            }

            queueAssignDealerFromZip();
        }

        zipInput.addEventListener("input", () => {
            enforceZipInputRules();
            clearZipError();
            clearDealerFields();
        });

        zipInput.addEventListener("blur", handleZipBlur);
        productType.addEventListener("change", () => {
            clearDealerFields();
            handleZipBlur();
        });
        countrySelect.addEventListener("change", () => {
            enforceZipInputRules();
            clearZipError();
            clearDealerFields();
            handleZipBlur();
        });

        if (form) {
            form.addEventListener(
                "submit",
                function (event) {
                    if (bypassSubmitGuard || !shouldReassignDealerOnSubmit()) {
                        return;
                    }

                    event.preventDefault();
                    event.stopPropagation();

                    queueAssignDealerFromZip().then((assigned) => {
                        if (assigned === null || assigned === false) {
                            return;
                        }

                        bypassSubmitGuard = true;
                        form.requestSubmit();
                        bypassSubmitGuard = false;
                    });
                },
                true
            );
        }
    }

    function calculateDistance(lat1, lon1, lat2, lon2) {
        const R = 3958.8;
        const dLat = degreesToRadians(lat2 - lat1);
        const dLon = degreesToRadians(lon2 - lon1);
        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(degreesToRadians(lat1)) *
                Math.cos(degreesToRadians(lat2)) *
                Math.sin(dLon / 2) *
                Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
    }

    function degreesToRadians(degrees) {
        return degrees * (Math.PI / 180);
    }
})();
